export function validateSlotContent(slot: HTMLSlotElement, allowedTags: string[], allowText: boolean, warningMessage: string): void {
	const invalid: Node[] = slot?.assignedNodes({ flatten: true }).filter((node: Node) => {
		if (node.nodeType === Node.TEXT_NODE) {
			const text = node.textContent?.trim() ?? '';
			return !allowText && text.length > 0;
		}
		if (node.nodeType === Node.ELEMENT_NODE) {
			const el = node as Element;
			const tagName = el.tagName.toUpperCase();
			// Top-level must be an allowed tag
			if (!allowedTags.includes(tagName)) {
				return true;
			}
			// And it must not contain any nested element children
			const hasNestedElements = Array.from(el.childNodes).some((child) => child.nodeType === Node.ELEMENT_NODE);
			return hasNestedElements;
		}
		return false;
	});

	if (invalid?.length > 0) {
		console.warn(warningMessage, ...invalid);
	}
}
